'use client';
import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScPromoSnackbar = styled.div<{ popupHeight: number }>`
  width: 347px;
  height: 32px;
  position: absolute;
  bottom: -40px;
  z-index: 11;
  ${typography['caption1regular']}
  background: rgba(9, 9, 9, 0.7);
  border-radius: 4px;

  display: flex;
  gap: 8px;
  padding: 4px 8px;

  .content {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
  }

  &:hover {
    cursor: initial;
  }

  @media (${device.tablet}) {
    position: fixed;
    top: ${({ popupHeight }) =>
      popupHeight ? `${popupHeight + 56}px` : '56px'};
    left: 50%;
    transform: translateX(-50%);
  }
`;
